import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Table, Row, Button, Drawer, Divider, Input, message } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import { NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, showErrorInNotification, formatMoney } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { CustomButton } from '../../../components/basic_items';


const queryString = require('query-string');

const setting_cols = ({ props, onChange }) => [
    {
        title: "Name",
        dataIndex: 'name',
        key: 'name',
    },


    {
        title: "Action",
        dataIndex: 'identifier',
        key: 'actions',
        align: 'center',
        width: 200,
        render: (id, data) => {
            return <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
            }}>
                {!data.enabled ? <CustomButton
                    className='success-btn' onClick={() => {
                        typeof onChange === 'function' && onChange(data.id,true)
                    }}
                    label="ENABLE"
                /> :
                    <CustomButton onClick={() => {
                        typeof onChange === 'function' && onChange(data.id,false)
                    }} className='danger-btn'
                        label="DISABLE"
                    />
                }
            </div>
        }
    }
]
class MakerCheckerList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            add_edit_status: null,
            edit_config_id: null,
            filter_query: {}
        };

        this.list_makercheckers = RESTExecutor.list().config({
            label: 'listSettings',
        }).connect(props.domains.makerchecker);

        this.list_makercheckers.execute();

        this.toggle_makerchecker = RESTExecutor.post().config({
            label: 'toggle',
        }).callbacks((success) => {
            message.success(success.result.message || "Maker Checker Updated");
            this.list_makercheckers.execute()

        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.makerchecker);

        this.enable_makerchecker = RESTExecutor.post().config({
            label: 'enable',
        }).callbacks((success) => {
            message.success(success.result.message || "Maker Checker Enabled");
            this.list_makercheckers.execute()
        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.makerchecker);

        this.disable_makerchecker = RESTExecutor.post().config({
            label: 'disable',
        }).callbacks((success) => {
            message.success(success.result.message || "Maker Checker Disabled");
            this.list_makercheckers.execute()
        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.makerchecker);


        this.delay_search = new NetworkDelaySearch();


    };

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        let list_makercheckers_resp = this.list_makercheckers.response();
        let list_makercheckers_data = list_makercheckers_resp.result || {};
        let toggle_makerchecker_resp = this.toggle_makerchecker.response();

        let rowsData = list_makercheckers_data.rows || [];
        let rowsMeta = list_makercheckers_resp.meta || {};
        const { filter_query } = this.state;

        return (
            <div>
                <ErrorWrapper
                    error={list_makercheckers_resp}
                    onReload={() => {
                        this.list_makercheckers.execute()
                    }}
                >


                    <div
                        // className='default-card' 
                        style={{ padding: 0 }}>
                        <Table
                            className='main-table'
                            loading={list_makercheckers_resp.fetching || toggle_makerchecker_resp.fetching}
                            size='small'
                            scroll={{ x: true }}
                            pagination={{
                                simple: false,
                                position: 'bottom',
                                onChange: (current, size) => {
                                    this.props.history.push({
                                        search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                    })
                                },
                                defaultCurrent: 1,
                                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                // defaultPageSize: 20,
                                pageSize: (rowsMeta && rowsMeta.requested_count),

                                total: (rowsMeta && rowsMeta.total_count),
                                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                            }}
                            // bordered={false}
                            rowKey={(record) => record.id}
                            columns={setting_cols({
                                onChange: (id,status) => {
                                    if(status){
                                        // Enable maker checker
                                        this.enable_makerchecker.forId(id).execute()
                                    }else{
                                        //disable maker checker
                                        this.disable_makerchecker.forId(id).execute()
                                    }
                                    // this.toggle_makerchecker.forId(id).execute();
                                }
                            })}
                            dataSource={rowsData}
                        />


                    </div>
                </ErrorWrapper>
            </div>
        )
    }

    componentDidMount() {
        // overrideHeaderTitle("Cron Configs");
        // overrideHeaderBack(null);
        // let new_filter_query = {};
        // if (this.props.location && this.props.location.search) {
        //     const parsed = queryString.parse(this.props.location.search);
        //     new_filter_query = parsed;
        // }
        // this.setState({
        //     filter_query: {
        //         per_page: 100,
        //         page: 1,
        //         ...new_filter_query
        //     }
        // }, () => {
        //     this.list_makercheckers.config({
        //         params: {
        //             ...this.state.filter_query
        //         }
        //     }).execute()
        // })



    }
    componentWillReceiveProps(nextProps) {

        // let new_filter_query = {};
        // if ((this.props.location.search !== nextProps.location.search)) {
        //     const parsed = queryString.parse(nextProps.location.search);
        //     new_filter_query = parsed;
        //     this.setState({
        //         filter_query: {
        //             per_page: 100,
        //             page: 1,
        //             ...new_filter_query
        //         }
        //     }, () => {
        //         this.list_makercheckers.config({
        //             params: {
        //                 ...this.state.filter_query
        //             }
        //         }).execute()
        //     })
        // } else {
        //     //   this.list_logs.execute()
        // }


    }
}


export default withDomains(MakerCheckerList, "makerchecker");
